import app from 'flarum/forum/app';
import PaginatedListState from 'flarum/common/states/PaginatedListState';
export default class DialogListState extends PaginatedListState {
  lastCount = 0;
  constructor(params, page, perPage) {
    if (page === void 0) {
      page = 1;
    }
    if (perPage === void 0) {
      perPage = null;
    }
    super(params, page, perPage);
  }
  get type() {
    return 'dialogs';
  }
  getAllItems() {
    return super.getAllItems();
  }
  requestParams() {
    const params = {
      include: ['lastMessage.user', 'users.groups'],
      filter: this.params.filter || {},
      sort: this.currentSort() || this.sortValue(Object.values(this.sortMap())[0])
    };
    return params;
  }
  sortMap() {
    const map = {};
    map.latest = '-lastMessageAt';
    map.newest = '-createdAt';
    map.oldest = 'createdAt';
    return map;
  }
  load() {
    if (app.session.user?.attribute('unreadDialogCount') !== this.lastCount) {
      this.pages = [];
      this.location = {
        page: 1
      };
      this.lastCount = app.session.user?.attribute('unreadDialogCount') || 0;
    }
    if (this.pages.length > 0) {
      return Promise.resolve();
    }
    return super.loadNext();
  }

  /**
   * Puts a dialog at the top of the list, as a new message in it does, without
   * reloading. A list that hasn't loaded yet is left alone: it loads fresh.
   *
   * @param limit Keep the first page to this many dialogs, for short lists like the dropdown's.
   */
  moveToTop(dialog, limit) {
    if (!this.pages.length) return;
    const id = dialog.id();
    this.pages.forEach(page => {
      const index = page.items.findIndex(item => item.id() === id);
      if (index !== -1) page.items.splice(index, 1);
    });
    this.pages[0].items.unshift(dialog);
    if (limit && this.pages[0].items.length > limit) this.pages[0].items.length = limit;
  }
  markAllAsRead() {
    return app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/dialogs/read'
    }).then(() => {
      app.dialogs.getAllItems().forEach(dialog => {
        dialog.pushAttributes({
          unreadCount: 0
        });
      });
      app.session.user.pushAttributes({
        unreadDialogCount: 0
      });
      app.dropdownDialogs.clear();
      m.redraw();
    });
  }
}
flarum.reg.add('flarum-messages', 'forum/states/DialogListState', DialogListState);